module.exports = __webpack_public_path__ + "img/logo.b125007b.png";